import React, { Component, createRef } from "react";
import * as s from "./DocumentInformation.module.scss";
import {
  P,
  BackgroundImage,
  DocumentFilesDropdown,
  ShareButton,
  ModalToolbar,
} from "src/views/shared/components";
import { ISingleWordpressDocument } from "src/models";
import { DocumentInformationReference } from "./DocumentInformationReference";
import { tx } from "src/libs/i18n";

interface Props {
  toggleOverlay: any;
  document: ISingleWordpressDocument;
}

interface State {
  downloadViewSelected: boolean;
}

export class DocumentInformation extends Component<Props, State> {
  private linkRef = createRef<any>();

  constructor(props) {
    super(props);
    this.state = {
      downloadViewSelected: true,
    };
  }

  copyToClipboard = () => {
    this.linkRef.current.select();
    document.execCommand("copy");
  };

  toggleContentView = () => {
    this.setState({
      downloadViewSelected: !this.state.downloadViewSelected,
    });
  };

  render() {
    const { downloadViewSelected } = this.state;
    const { toggleOverlay, document } = this.props;
    const { documentThumbnail, title, link, documentFields } = document;
    const { documents } = documentFields;

    let leftButtonClasses = [s.toggleViewButton, s.left];
    let rightButtonClasses = [s.toggleViewButton, s.right];

    downloadViewSelected
      ? leftButtonClasses.push(s.active)
      : rightButtonClasses.push(s.active);

    const documentLanguages =
      (documents &&
        documents.map(document => document?.documentLanguage?.name)) ||
      [];
    const documentsByLanguage = {};
    documentLanguages.forEach(lang => {
      documentsByLanguage[lang] =
        documents &&
        documents.filter(document => document?.documentLanguage?.name === lang);
    });
    const documentsMissingLanguage = documents.filter(
      document => !document.documentLanguage
    );
    return (
      <div className={s.documentInformationModal}>
        <ModalToolbar title={"document.Document"} onClose={toggleOverlay} />
        <div className={s.contentContainer}>
          {documentThumbnail?.image && (
            <div className={s.documentImage}>
              <BackgroundImage image={documentThumbnail.image} />
            </div>
          )}
          <h6 className={s.documentTitle}>{title}</h6>
          <div className={s.shareContainer}>
            <P medium>{tx("misc.share")}</P>
            <div className={s.shareIconsContainer}>
              {/* TODO: Replace share url with correct document url */}
              <ShareButton className={s.shareIcon} type="twitter" url={link} />
              <ShareButton className={s.shareIcon} type="facebook" url={link} />
              <ShareButton className={s.shareIcon} type="linkedin" url={link} />
              <ShareButton className={s.shareIcon} type="email" url={link} />
              <ShareButton className={s.shareIcon} type="skype" url={link} />
            </div>
          </div>
          {/* <div className={s.toggleViewContainer}>
            <div className={leftButtonClasses.join(" ")} onClick={this.toggleContentView}>
              <P small>{tx("buttons.viewAndDownload")}</P>
            </div>
            <div
              className={rightButtonClasses.join(" ")}
              onClick={this.toggleContentView}
            >
              <P small>{tx("buttons.referenceGenerator")}</P>
            </div>
          </div> */}
          {/* {downloadViewSelected && ( */}
          <div className={s.languagesContainer}>
            {documentLanguages?.length > 1 && (
              <P small className={s.documentLanguageDropdownLabel}>
                {tx("languages.autodetectedLanguage")}
              </P>
            )}
            {!documentLanguages[0] && (
              <DocumentFilesDropdown
                documents={documentsMissingLanguage}
                title={"English"}
              />
            )}
            {documentLanguages[0] && (
              <DocumentFilesDropdown
                documents={documentsByLanguage[documentLanguages[0]].concat(
                  documentsMissingLanguage
                )}
                title={documentLanguages[0]}
              />
            )}

            {documentLanguages.length > 1 && (
              <>
                <P small className={s.documentLanguageDropdownLabel}>
                  {tx("languages.otherLanguages")}
                </P>
                {documentLanguages &&
                  documentLanguages.splice(1).map((lang, i) => {
                    if (lang) {
                      return (
                        <DocumentFilesDropdown
                          key={i}
                          documents={documentsByLanguage[lang]}
                          title={lang}
                        />
                      );
                    }
                  })}
              </>
            )}
          </div>
          {/* )} */}
          {/* {!downloadViewSelected && (
            <div className={s.referenceContainer}>
              <DocumentInformationReference />
            </div>
          )} */}
        </div>
      </div>
    );
  }
}
